module.exports = __webpack_public_path__ + "static/media/background.f5022de4.png";